<template>
  <div>
    <icon-view
      icon="fas fa-map-marker-alt text-orange"
      icon-background="white"
      title="Información de Localidad"
    />
    <div class="row mt-3">
      <div class="col-12 col-md-4">
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.locationType"
              :options="locationTypes"
              label="Tipo de Localidad:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100  bold-label"
              custom-error-msg="Este campo es requerido"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group">
          <validation-provider mode="eager">
            <custom-input
              v-model="model.location"
              type="text"
              label="Datos de Ubicación / Dirección:"
            />
          </validation-provider>
        </div>
      </div>
      <div v-if="!isCSEELocationType" class="col-12 col-md-4">
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.center"
              :options="centers"
              label="Centro:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100  bold-label"
              @input="val => $emit('center', val)"
              custom-error-msg="Este campo es requerido"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        v-if="!isCSEELocationType && !isCenterLocationType"
        class="col-12 col-md-4"
      >
        <div class="form-group">
          <validation-provider
            mode="eager"
            rules="required"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.municipality"
              :options="municipalities"
              label="Municipio:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100  bold-label"
              @input="val => $emit('municipality', val)"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
            />
          </validation-provider>
        </div>
      </div>
      <div v-if="!showSchool && !isCSEELocationType" class="col-12 col-md-4">
        <div class="form-group">
          <validation-provider
            mode="eager"
            :rules="hasMunicipality ? 'required' : ''"
            v-slot="{ errors }"
          >
            <custom-drop-down
              v-model="model.school"
              :options="schools"
              label="Escuela:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 bold-label"
              custom-error-msg="Este campo es requerido"
              :error="errors[0]"
              @input="val => $emit('school', val)"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from "icon-view";
import CustomDropDown from "custom-drop-down";
import CustomInput from "CustomInput";
import LocationTypes from "@/utils/constants/inventory/inventoryOrderBookLocationTypes";

export default {
  name: "LocationInfo",
  components: {
    IconView,
    CustomDropDown,
    CustomInput
  },
  props: {
    centers: {
      type: Array,
      require: true,
      default: () => []
    },
    locationTypes: {
      type: Array,
      require: true,
      default: () => []
    },
    municipalities: {
      type: Array,
      require: true,
      default: () => []
    },
    schools: {
      type: Array,
      require: true,
      default: () => []
    },
    value: {
      type: Object,
      require: true,
      default: () => ({
        center: null,
        municipality: null,
        school: null,
        location: null,
        locationType: null
      })
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    hasMunicipality() {
      return Boolean(this.model.municipality);
    },
    isCSEELocationType() {
      return Boolean(
        this.model.locationType?.id == LocationTypes.CSEE.id ||
          this.model.locationType?.id == null
      );
    },
    isCenterLocationType() {
      return LocationTypes.CENTER.id == this.model.locationType?.id;
    },
    showSchool() {
      return [LocationTypes.CENTER.id, LocationTypes.CSEE.id].includes(
        this.model.locationType?.id
      );
    }
  },
  watch: {
    "model.locationType"(newVal, oldVal) {
      if (oldVal != null && newVal !== oldVal) {
        this.model.center = null;
        this.model.school = null;
        this.model.municipality = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dot > em {
  font-size: 16px !important;
}
</style>
